import { StateCreator } from "zustand";
import {
HeatedSegment,
MAIN_PROPERTIES,
  MAIN_PROPERTIES_DEFAULT,
  MAIN_PROPERTY_HINTS,
  MAIN_PROPERTY_LABELS,
  MAIN_PROPERTY_PLACEHOLDERS,
  MainPropertyKey,
  MainPropertyValue,
  RoofOrientation,
  type MainPropertiesDeclare,
} from "./properties.ts";
import type  GebaeudeTyp from "./types.ts";
import { AppSlice } from "./app-slice.ts";
import { ApiSlice } from "./api-slice.ts";

let menu_timeout : number | undefined = undefined;

export interface PropertySlice {
  get_property_config: (key: MainPropertyKey) => MainPropertiesDeclare | undefined;
  get_property_label: (key: MainPropertyKey) => string;
  get_property_hint: (key: MainPropertyKey) => string;
  get_property_placeholder: (key: MainPropertyKey) => string;
  get_property: (key: MainPropertyKey) => MainPropertyValue;
  get_property_as_string: (key: MainPropertyKey) => string;
  get_property_as_number: (key: MainPropertyKey) => number;
  set_property: (key: MainPropertyKey, value: MainPropertyValue) => void;
  init_property_if_undefined: (key: MainPropertyKey) => void;
  gebaeude_typ?: GebaeudeTyp;
  postleitzahl?: string;
  vollgeschosse?: number;
  wohneinheiten?: number;
  baujahr? : number;
  wohnflaeche?: number;
  oelverbrauch?: number;
  stromverbrauch? : number;
  gasverbrauch?: number;
  gasverbrauch_m3?: number;
  holzverbrauch_t?: number;
  holzverbrauch_m3?: number;
  holzverbrauch?: number;
  stromverbrauchwaermepumpe?: number;
  budget?: number;
  privat: boolean;
  massnamen_empfehlen?: boolean;
  beheizte_segmente?: HeatedSegment;
  darlehen?: number; 
  kostensteigerung_energie?: number;
  co2_price?: number;
  heizung?: string;
  verbrauchseinheit_oel: "liter";
  verbrauchseinheit_gas: "kWh" | "m3";
  verbrauchseinheit_holz: "m3" | "t" | "kg";
  verbrauchseinheit_andere: "kWh";

  heizung_future?: string;
  heizung_datum?: number;
  heizung_kosten?: number;
  heizung_natural_refrigerant?: number;
  heizung_natural_refrigerant_future?: number;
  heizung_dust_emission?: number;
  hot_water?: string;

  keller?: string;
  keller_future?: string;
  keller_datum?: number;
  keller_kosten?: number;
  dach?: string;
  dach_future?: string;
  income_gt_4k?: boolean;
  heizung_wird_ausgetauscht?: boolean;
  // dach_future_schraege?: string;
  // dach_future_decke?: string;
  dach_datum?: number;
  dach_kosten?: number;
  fenster?: string;
  fenster_future?: string;
  fenster_datum?: number;
  fenster_kosten?: number;
  fassade?: string;
  fassade_future?: string;
  fassade_datum?: number;
  fassade_kosten?: number;
  solarthermie?: string;
  solarthermie_future?: string;
  solarthermie_datum?: number;
  solarthermie_kosten?: number;
  solarthermie_kollektorflaeche?: number,
  solarthermie_speichergroeße?: number,
  solarthermie_kollektorflaeche_future?: number,
  solarthermie_speichergroeße_future?: number,
  photovoltaik?: string;
  photovoltaik_future?: string;
  photovoltaik_datum?: number;
  photovoltaik_kosten?: number;
  lueftung?: string;
  lueftung_future?: string;
  lueftung_datum?: number;
  lueftung_kosten?: number;
  solarthermie_roof_pitch?: number;
  solarthermie_orientation?: RoofOrientation;
  solarthermie_roof_pitch_future?: number;
  solarthermie_orientation_future?: RoofOrientation;
  solarthermie_natural_refrigerant?: boolean;
  photovoltaik_roof_pitch?: number;
  photovoltaik_orientation?: RoofOrientation;
  photovoltaik_annual_yield_kWh?: number;
  photovoltaik_battery_storage?: boolean;
  photovoltaik_roof_pitch_future?: number;
  photovoltaik_orientation_future?: RoofOrientation;
  photovoltaik_battery_storage_future?: boolean;
}

export const PROPERTIES_DEFAULT = {
  gebaeude_typ:undefined,
  postleitzahl:undefined,
  vollgeschosse:undefined,
  wohneinheiten:undefined,
  baujahr:undefined,
  wohnflaeche:undefined,
  oelverbrauch:undefined,
  stromverbrauch:undefined,
  gasverbrauch:undefined,
  holzverbrauch:undefined,
  stromverbrauchwaermepumpe:undefined,
  budget:undefined,
  privat:true,
  massnamen_empfehlen:undefined,
  beheizte_segmente:undefined,
  darlehen:undefined, 
  kostensteigerung_energie:3,
  co2_price:55,
  heizung:"heating_system_current_0",
  verbrauchseinheit_oel: "liter",
  verbrauchseinheit_gas: "kWh",
  verbrauchseinheit_holz: "m3",
  verbrauchseinheit_andere: "kWh",
  heizung_future:undefined,
  heizung_datum:undefined,
  heizung_kosten:undefined,
  heizung_natural_refrigerant:undefined,
  heizung_natural_refrigerant_future:undefined,
  hot_water: "",
  keller:undefined,
  keller_future:undefined,
  keller_datum:undefined,
  keller_kosten:undefined,
  dach:undefined,
  dach_future:undefined,
  income_gt_4k:undefined,
  heizung_wird_ausgetauscht:undefined,
  dach_datum:undefined,
  dach_kosten:undefined,
  fenster:undefined,
  fenster_future:undefined,
  fenster_datum:undefined,
  fenster_kosten:undefined,
  fassade:undefined,
  fassade_future:undefined,
  fassade_datum:undefined,
  fassade_kosten:undefined,
  solarthermie:undefined,
  solarthermie_future:undefined,
  solarthermie_datum:undefined,
  solarthermie_kosten:undefined,
  solarthermie_kollektorflaeche:undefined,
  solarthermie_speichergroeße:undefined,
  solarthermie_kollektorflaeche_future:undefined,
  solarthermie_speichergroeße_future:undefined,
  photovoltaik:undefined,
  photovoltaik_future:undefined,
  photovoltaik_datum:undefined,
  photovoltaik_kosten:undefined,
  lueftung:undefined,
  lueftung_future:undefined,
  lueftung_datum:undefined,
  lueftung_kosten:undefined,
  solarthermie_roof_pitch: undefined,
  solarthermie_orientation: undefined,
  solarthermie_roof_pitch_future: undefined,
  solarthermie_orientation_future: undefined,
  solarthermie_natural_refrigerant: undefined,
  photovoltaik_roof_pitch: undefined,
  photovoltaik_orientation: undefined,
  photovoltaik_annual_yield_kWh: undefined,
  photovoltaik_battery_storage: undefined,
  photovoltaik_roof_pitch_future: undefined,
  photovoltaik_orientation_future: undefined,
  photovoltaik_battery_storage_future: undefined,

};

export const createPropertySlice: StateCreator<AppSlice & ApiSlice & PropertySlice, [], [], PropertySlice> = (
  set,
  get,
) => ({
  heizung: "heating_system_current_0",
  kostensteigerung_energie: 3,
  co2_price: 55,
  properties_changed: [],
  propertyUpdate: 0,
  privat:true,

  get_property_config: (key) => {
    return MAIN_PROPERTIES.find(property => property.key == key);
  },
  get_property_label: (key) => {
    return MAIN_PROPERTY_LABELS[key] ?? "";
  },
  get_property_hint: (key) => {
    return MAIN_PROPERTY_HINTS[key] ?? "";
  },
  get_property_placeholder: (key) => {
    return MAIN_PROPERTY_PLACEHOLDERS[key] ?? "";
  },
  get_property: (key) => {
    return get()[key] as unknown as MainPropertyValue;
  },
  get_property_as_number: (key) => {
    const x = parseInt(get()[key] as unknown as string);
    return Number.isNaN(x) ? 0 : x;
  },
  get_property_as_string : (key) => {
    let prop = get()[key] as unknown;
    if (prop !== null && prop !== undefined){
      return prop.toString();
    }
    return "";
  },
  set_property: (key, value) => {
    if (
      key == "heizung_isfp" ||
      key == "keller_isfp" ||
      key == "dach_isfp" ||
      key == "fenster_isfp" ||
      key == "fassade_isfp" ||
      key == "solarthermie_isfp" ||
      key == "photovoltaik_isfp" ||
      key == "lueftung_isfp"
    ){
      set((_state) => ({ 
        heizung_isfp: value,
        keller_isfp: value,
        dach_isfp: value,
        fenster_isfp: value,
        fassade_isfp: value,
        solarthermie_isfp: value,
        photovoltaik_isfp: value,
        lueftung_isfp : value,
      }));
    }
    set((_state) => ({ [key] : value }));
  },
  init_property_if_undefined: (key, value) => {
    if (get()[key] == undefined){
      const prop = MAIN_PROPERTIES.find((p) => p.key == key);
      if (prop){
        set((_state) => ({ [key] : prop.default }));
      }
    }
  },
  beheizte_segmente: [0,100,0],
  //...MAIN_PROPERTIES_DEFAULT,
});
